export default {
  setPaymentList(state, entity) {
    state.paymentList = entity.list;
    state.pageInfo = entity.pageInfo;
  },

  setPaymentInfo(state, entity) {
    state.paymentInfo = entity;
  }
};
